import React from "react";
import {Button} from "@reside/ui";

interface ResidentToggleButtonProps {
  isArchived: boolean;
  residentId: string;
  onHide: (id: string) => void;
  onShow: (id: string) => void;
}

export const ResidentToggleButton = ({
  isArchived,
  residentId,
  onHide,
  onShow,
}: ResidentToggleButtonProps): JSX.Element => {
  const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isArchived) {
      onShow(residentId);
    } else {
      onHide(residentId);
    }
  };

  return (
    <Button
      color={isArchived ? "default" : "danger"}
      outline={!isArchived}
      onClick={handleToggle}
    >
      {isArchived ? "Show resident" : "Hide resident"}
    </Button>
  );
};
